module.exports = __webpack_public_path__ + "img/globe.e1a2282a.svg";